import { apiClient } from '../lib/apiClient';

export type PresignedDownloadItem = {
  key: string;
  url: string;
};

export type PresignedDownloadResponse = {
  items: PresignedDownloadItem[];
  expiresIn?: number;
};

export type PresignedDownloadResult = {
  items: PresignedDownloadItem[];
  expiresIn?: number;
  expiresAtMs?: number;
};

export const getPresignedDownloadUrlExpiresAtMs = (
  expiresIn?: number,
  nowMs: number = Date.now()
): number | undefined => {
  const seconds = Number(expiresIn);
  if (!Number.isFinite(seconds) || seconds <= 0) return undefined;
  return nowMs + seconds * 1000;
};

export const postPresignedDownloadUrlsWithMeta = async (
  fileKeys: string[],
  signal?: AbortSignal
): Promise<PresignedDownloadResult> => {
  const payload = { filekeys: fileKeys };
  const res = await apiClient.post<PresignedDownloadResponse>(
    '/s3_presigned_download',
    payload,
    { signal }
  );
  const expiresIn = res.data.expiresIn;
  return {
    items: res.data.items ?? [],
    expiresIn,
    expiresAtMs: getPresignedDownloadUrlExpiresAtMs(expiresIn),
  };
};

export const postPresignedDownloadUrls = async (
  fileKeys: string[],
  signal?: AbortSignal
): Promise<PresignedDownloadItem[]> => {
  const res = await postPresignedDownloadUrlsWithMeta(fileKeys, signal);
  return res.items;
};
